import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const navigate = useNavigate();


  // const handleCreateStory = () => { // Unused
  //   navigate('/story-setup');
  // };

  const handleGoToWorkshop = () => {
    navigate('/character-builder');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-pink-50 to-blue-100">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold text-gray-800 mb-4">
              Welcome to the Magic Story Factory
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Where your wildest dreams come to life! Create amazing adventures with magical characters, exciting scenes, and fun animations.
            </p>
          </div>

          {/* Main Action Card */}
          <div className="max-w-xl mx-auto mb-6">
            {/* Imagination Station Card */}
            <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">💡</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-800 mb-3">
                  Imagination Station
                </h2>
                <p className="text-gray-600 mb-6 max-w-md mx-auto">
                  Create new stories or continue working on your existing adventures.
                </p>
                <button
                  onClick={handleGoToWorkshop}
                  className="px-8 py-3 rounded-xl text-lg font-semibold transition-all duration-200 shadow-lg bg-gradient-to-r from-blue-600 to-cyan-600 text-white hover:from-blue-700 hover:to-cyan-700 hover:shadow-xl hover:scale-105"
                >
                  Enter Imagination Station
                </button>
              </div>
            </div>
          </div>

          {/* Library - AI Characters, AI Scenes, AI Videos, Video Editor */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <button
              onClick={() => navigate('/characters')}
              className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 text-center hover:shadow-xl hover:scale-105 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">👥</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">AI Characters</h3>
              <p className="text-gray-600 text-sm">
                Create unique characters.
              </p>
            </button>

            <button
              onClick={() => navigate('/scenes')}
              className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 text-center hover:shadow-xl hover:scale-105 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎬</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">AI Scenes</h3>
              <p className="text-gray-600 text-sm">
                Create and manage your scenes.
              </p>
            </button>


            <button
              onClick={() => navigate('/videos')}
              className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 text-center hover:shadow-xl hover:scale-105 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎞️</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">AI Videos</h3>
              <p className="text-gray-600 text-sm">
                Create videos from frames.
              </p>
            </button>

            <button
              onClick={() => navigate('/video-editor')}
              className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 text-center hover:shadow-xl hover:scale-105 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">✂️</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Video Editor</h3>
              <p className="text-gray-600 text-sm">
                Edit and combine your videos.
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
